import {useEffect, useState} from "react";
import classes from "../events/events.module.css";
import small_g from "../../images/small-groups.jpg"
import steps from "../../images/steps.jpg"
import prayer from "../../images/prayer.jpg"
import church_event from "../../images/church-event.jpg"
import AnimatedPage from "../../animations/AnimatedPage";
import {Container} from "react-bootstrap";
import {EventsAnimation} from "../../animations/Animations";


const events = [
    {
        img: `${steps}`,
        title: "Программа \"Шаги восстановления\"\n" +
            "(Христоцентричная группа взаимоподдержки)",
        time: "Понедельник 19:00-21:00",
        className: "small-groups"
    },
    {
        img: `${small_g}`,
        title: "Малые группы",
        time: "Четверг, 19:00 - 21:00",
        className: "small-groups"
    },
    {
        img: `${prayer}`,
        title: "Утренняя молитва",
        time: "Суббота, 09:00 - 10:00",
        className: "morning-prayer"
    },
    {
        img: `${church_event}`,
        title: "Богослужение",
        time: "Воскресенье, 10:00 - 12:00",
        className: "worship-service"
    },

];

const Events = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setTimeout(() => setVisible(true), 300);
    }, []);
    const getStyleImage = (img) => {
        return {
            background: `url(${img})`,
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundColor: 'var(--surface-2)',
            width: '100%',
            aspectRatio: '1 / 1'
        }
    }

    return (
        <div className={'container'}>
            {!visible ? <AnimatedPage/> :
                <EventsAnimation>
                    <Container className="py-5">
                        <h2>Наши мероприятия</h2>
                        <div className="row g-4 justify-content-center">
                            {events.map((event, index) => (
                                <div key={index} className="col-12 col-md-6">
                                    <div
                                        className={`${classes.wrapper} h-100`}
                                        style={{transitionDelay: `${index * 200}ms`}}
                                    >
                                        <div className={'image-container'} style={getStyleImage(event.img)}>

                                        </div>
                                        <div className="p-4">
                                            <h3 style={{fontWeight: 600, marginBottom: 8}}>{event.title}</h3>
                                            <p style={{color: 'var(--text-muted)', marginTop: 8}}>{event.time}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Container>
                </EventsAnimation>
            }
        </div>
    );
};

export default Events;
